import { styled } from '../../hooks/theme';
import { Tokens } from '../../types';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;

  padding: 16px 0px 16px 0px;

  border-bottom: 1px solid ${props => props.theme.colors.neutral.grey[10]};
`;

Container.defaultProps = {
  theme: Tokens.eixods,
};

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

Content.defaultProps = {
  theme: Tokens.eixods,
};

export const TextSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
  height: 90%;
`;

TextSection.defaultProps = {
  theme: Tokens.eixods,
};

export const IconsSection = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

IconsSection.defaultProps = {
  theme: Tokens.eixods,
};

export const Title = styled.title`
  font-weight: ${props => props.theme.font.weights.semibold};
  font-size: ${props => props.theme.font.size.base + 'px'};
  line-height: ${props => props.theme.font.desktop.paragraph.p1.semibold.lineHeight};

  display: flex;
  align-items: center;
  padding: 3px 0px 3px 0px;

  color: ${props => props.theme.colors.neutral.grey[100]};
`;

Title.defaultProps = {
  theme: Tokens.eixods,
};

export const Subtitle = styled.title`
  font-weight: ${props => props.theme.font.weights.regular};
  font-size: ${props => props.theme.font.size.sm + 'px'};
  line-height: ${props => props.theme.font.desktop.paragraph.p2.regular.lineHeight};

  display: flex;
  align-items: center;

  color: ${props => props.theme.colors.neutral.grey[70]};
`;

Subtitle.defaultProps = {
  theme: Tokens.eixods,
};
